import { AST } from '@handlebars/parser';
import { concatenate, joinWithSpaces } from 'utils/stringHelpers';
import { serializeHandlebar } from '../../../utils/serializeHandlebar';
import { ExpressionSerializer } from '../../expression/serializer';
import { BLOCK_CLOSE_PREFIX, BLOCK_OPEN_PREFIX, INVERSE_BLOCK_PATH } from '../constants';
import { StatementListSerializerFn } from '../types';
import { StatementArgsSerializer } from './args';

export class BlockStatementSerializer {
  static serialize = (statement: AST.BlockStatement, serializeAll: StatementListSerializerFn) => {
    const body = serializeAll(statement.program.body);
    const inverse = BlockStatementSerializer.hasInverse(statement)
      ? serializeAll(statement.inverse.body)
      : '';
    const openingTag = BlockStatementSerializer.serializeBlockStatementOpenTag(statement);
    const inverseTag = BlockStatementSerializer.serializeBlockStatementInverseTag(statement);
    const closingTag = BlockStatementSerializer.serializeBlockStatementCloseTag(statement);
    return concatenate([openingTag, body, inverseTag, inverse, closingTag]);
  };

  private static serializeBlockStatementOpenTag = (statement: AST.BlockStatement) => {
    const path = ExpressionSerializer.serialize(statement.path);
    const prefix = concatenate([BLOCK_OPEN_PREFIX, path]);
    return serializeHandlebar(
      joinWithSpaces([prefix, StatementArgsSerializer.serialize(statement)]),
      statement.openStrip,
    );
  };

  private static serializeBlockStatementCloseTag = (statement: AST.BlockStatement) => {
    const path = ExpressionSerializer.serialize(statement.path);
    return serializeHandlebar(concatenate([BLOCK_CLOSE_PREFIX, path]), statement.closeStrip);
  };

  private static serializeBlockStatementInverseTag = (statement: AST.BlockStatement) =>
    BlockStatementSerializer.hasInverse(statement)
      ? serializeHandlebar(INVERSE_BLOCK_PATH, statement.inverseStrip)
      : '';

  private static hasInverse = (statement: AST.BlockStatement) => !!statement.inverse?.body.length;
}
